import { ColumnApi } from '@ag-grid-community/core'

const IncludeAllColumns = undefined

/**
 * Convert an ag-grid IServerSideGetRowsParams to a list of displayed columns
 */
export function convertFields<T>(
  columnApi?: ColumnApi,
  excludeFields: string[] = [],
  mandatoryFields: string[] = [],
): string[] | undefined {
  // If not columnApi object exists, return all columns
  if (!columnApi) {
    return IncludeAllColumns
  }

  // Only get the displayed columns
  const cols = columnApi.getAllDisplayedColumns() ?? []
  const columnNames: Set<string> = new Set()

  for (const col of cols) {
    const def = col.getColDef()
    const field: string | undefined = def.field
    // If the column is in the excludeFields for this object, ignore this column, otherwise include
    if (field && !excludeFields.includes(field)) {
      columnNames.add(field)
    }
  }

  // If no columns exist, return all columns
  if (columnNames.size === 0) {
    return IncludeAllColumns
  }

  mandatoryFields.forEach(field => columnNames.add(field))

  return Array.from(columnNames.values())
}
